export default class Ages {
  static options(ageDemographics) {
    const ageValues = ageDemographics
      .map((x) => (x.code.includes(' ') ? x.code.split(' ')[1] : x.code))
      .filter((x) => x.includes('-') || x.includes('+'))
      .map((x) => (x.includes('-') ? x.split('-')[0] : x));
    const uniqueValues = Array.from(new Set(ageValues));
    if (uniqueValues.length > 1 && uniqueValues[uniqueValues.length - 1].includes('+')) {
      uniqueValues[uniqueValues.length - 1] = uniqueValues[uniqueValues.length - 1].replace('+', '');
      uniqueValues.push('∞');
    }
    return uniqueValues.length > 1 ? uniqueValues : [];
  }

  static optionsAgeGdr(ageDemographics) {
    const ageValues = ageDemographics.map((x) => (x.code.includes(' ') ? x.code.split(' ')[1] : x.code));
    return [...new Set(ageValues)].join(', ');
  }
}
